import { RootState } from "store/store";
import { connect } from "react-redux";
import { compose } from "redux";
import {
    setConsentStatus,
    setCustomerName,
} from "store/customers/customer-details/customer-details-actions";
import GeneralDetails from "./GeneralDetails";
import { getCustomerNames } from "store/customers/customers-selectors";
import withLoader from "hocs/withLoader/withLoader";
import { setIsUnsavedChangeAvailable } from "store/common/unsaved-data/unsaved-data-actions";

const mapStateToProps = (state: RootState) => {
    return {
        customerNames: getCustomerNames(state),
        customerDetails: state.customerDetailsReducer.customerDetails,
    };
};
const GeneralDetailsContainer = compose(
    connect(mapStateToProps, {
        setConsentStatus,
        setCustomerName,
        setIsUnsavedChangeAvailable,
    }),
    withLoader
)(GeneralDetails);

export default GeneralDetailsContainer;
